import request from '@/utils/request';

/**
 * @description 角色table表获取
 * @returns {Array}
 */

export function getRoleTable(data) {
  return request.post('admin/role/list', data);
}

/**
 * @description 删除当前角色
 * @param {string}  id
 * @returns {}
 */

export function deleteRoleTable(data) {
  return request.post('admin/role/delete', data);
}

/**
 * @description 修改角色
 * @param {string}  id
 * @param {string}  role
 * @param {string}  text
 * @returns {}
 */

export function editRole(data) {
  return request.post('admin/role/edit', data);
}

/**
 * @description 新增
 * @param {string}  role
 * @param {string}  text
 * @returns {}
 */

export function addRole(data) {
  return request.post('admin/role/store', data);
}

/**
 * @description 修改状态
 * @param {string}  role
 * @param {string}  status
 * @returns {}
 */

export function roleStatus(data) {
  return request.post('admin/role/status', data);
}

/**
 * @description 角色资源
 * @param {string}  userId
 * @param {string}  status
 * @returns {}
 */

export function roleResource(data) {
  return request.post('admin/role/resource', data);
}